import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { Alert, Badge, Card } from "../../../components/ui";
import { AppShell } from "../../../layouts/AppShell";
import { getMember } from "../api/memberApi";
import { MemberAdminDialogs } from "../components/MemberAdminDialogs";

export function MemberDetailPage() {
  const { memberId = "" } = useParams(); const queryClient = useQueryClient();
  const query = useQuery({ queryKey: ["member", memberId], queryFn: () => getMember(memberId), enabled: Boolean(memberId) });
  if (query.error) return <AppShell title="會員資料" breadcrumb={["管理後台", "會員管理", "會員資料"]}><Alert variant="danger">無法載入會員資料。</Alert></AppShell>;
  const member = query.data;
  return <AppShell title="會員資料" breadcrumb={["管理後台", "會員管理", "會員資料"]}><Card title={member?.registrantName ?? "載入中"}>{member && <><dl><dt>帳號</dt><dd>{member.username}</dd><dt>Email</dt><dd>{member.email}</dd><dt>角色</dt><dd><Badge>{member.role}</Badge></dd><dt>狀態</dt><dd><Badge>{member.status}</Badge></dd></dl><MemberAdminDialogs member={member} onChanged={(updated) => queryClient.setQueryData(["member", memberId], updated)} /></>}</Card></AppShell>;
}

